import { OrdinaryObject } from "src/modules/utils/shared/ordinary-object.model";
import { Utils } from "src/modules/utils/shared/utils";
import { TableCell } from "./table-cell.model";

export class TableRow<T = any> {

    id: string;
    raw: T;
    values: OrdinaryObject;
    style: string;
    styleClass: string;
    canDeleteInternal: boolean | ((row: TableRow) => boolean) = true;

    constructor(id: string, raw: T, values: OrdinaryObject = null, props?: Partial<TableRow>) {
        this.id = id;
        this.raw = raw;
        this.values = values ?? raw;
        if (props != null) {
            Object.assign(this, props);
        }
    }

    canDelete(): boolean {
        return Utils.isFunction(this.canDeleteInternal) ? (this.canDeleteInternal as any)(this) : this.canDeleteInternal;
    }

    getValue(key: string): any {
        return this.values[key] instanceof TableCell ? this.values[key].value : this.values[key];
    }

}
